import Vue from 'vue';
import EdHomeworkStudentListItem from '../ed-homework-student-list-item/ed-homework-student-list-item.vue';
import EdHomeworkFeedback from '../ed-homework-feedback/ed-homework-feedback.vue';
import EdHomeworkGrade from '../ed-homework-grade/ed-homework-grade.vue';
import EdListHomeworkLoading from '../ed-list-homework-loading/ed-list-homework-loading.vue';
import { EVENT_BUS } from '../../../content/values/events';
import { SECTION_TYPES } from '../../../content/values/sections';
import { STORE } from '@/core/store/core.store';
import { HOMEWORKS_EVENTS, HOMEWORK_STATUS, HOMEWORKS_API, TEACHER_WIDGET_TASK_TABS, _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { Status } from '@/models/status.model';

export default Vue.component('ed-homework-student-list', {
  name: 'ed-homework-student-list',
  props: [],
  components: {
    EdHomeworkStudentListItem,
    EdHomeworkFeedback,
    EdHomeworkGrade,
    EdListHomeworkLoading
  },
  data: () => {
    return {
      student: null,
      course: null,
      showHomeworkStudentsComponent: false,
      loadingHomeworks: false,
      page: null,
      isSaving: false,
      myComponent: null,
      currentHomework: null,
      homeworksStatus: new Status(),
      moreHomeworksStatus: new Status(),
      homeworkSelected: null,
    }
  },
  computed: {
    showSeeMore() {
      return this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected.homeworks.more;
    },
    passProps(){
      if(this.myComponent == 'ed-homework-grade'){
        return { params : this.currentHomework, title: this.$i18n.t('homeworks.setGrade')}
      }else if(this.myComponent == 'ed-homework-feedback'){
        return null
      }
      return null;
    },
    studentSelected() {
      return this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected;
    },
    homeworks() {
      let homeworks = this.studentSelected.homeworks.content;
      return homeworks
        .map(h => {
          return {
            ...h,
            key: `${h.id}${h.status}${h.homeworkDraftAssetInfo ? h.homeworkDraftAssetInfo.hash : ''}`
          }
        });
    },
    isHomeworksShow() {
      return this.$store.state.HomeworksStore.teacherWidgetTabSelected == TEACHER_WIDGET_TASK_TABS.BY_STUDENT;
    },
    listIdsToReload() {
      return this.$store.state.HomeworksStore.listIdsToReloadTasks;
    }
  },
  methods: {
    reloadStudent(modifiedCourse = false) {
      if(!this.studentSelected) {
        return;
      }
      if(modifiedCourse) {
        let exist = this.listIdsToReload.includes(this.studentSelected.courseId);
        if(!exist) return;
      }
      let student = {...this.studentSelected};
      student.homeworks.page = 0;
      this.setStudent(student, true);      
    },
    setStudent(student, isReload) {
      if(this.studentSelected && !isReload) {
        let { courseId, classId, id } = this.studentSelected;
        if(courseId !== student.courseId || classId !== student.classId || id !== student.id) {
          if(student.homeworks.content.length == 0 && student.homeworks.more) {
            this.getHomeworks(student, isReload);
            return;
          }
        }
        student.homeworks.content.length == 0 ? this.homeworksStatus.setEmpty() : this.homeworksStatus.setLoad();
        this.$store.commit(STORE.HOMEWORKS.MUTATIONS.SELECT_WIDGET_TEACHER_PERSON, student);
      } else {
        this.getHomeworks(student, isReload);
      }
    },
    getHomeworks(student, isReload) {
      this.getHomeworksAllList(student, this.homeworksStatus, isReload).then((homeworks) => {
        if(homeworks == 0) this.homeworksStatus.setEmpty();
      });
    },
    getMoreHomeworks() {
      this.getHomeworksAllList(this.studentSelected, this.moreHomeworksStatus, false);
    },
    getHomeworksList(student, status) {
      return new Promise((resolve, reject) => {
        status.setLoading();
        this.$store.dispatch(
          STORE.HOMEWORKS.ACTIONS.SELECT_WIDGET_TEACHER_PERSON_SELECTED,
          student
        ).then((homeworks) => {
          resolve(homeworks);
          status.setLoad();
        }).catch(() => {
          reject();
          status.setError();
        });
      }); 
    },
    getHomeworksAllList(student, status, isReload) {
      return new Promise((resolve, reject) => {
        status.setLoading();
        this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SELECT_WIDGET_TEACHER_PERSON_SELECTED_ALL,
          {student, isReload}
        ).then((homeworks) => {
          resolve(homeworks);
          isReload ? 
          this.$store.commit(STORE.HOMEWORKS.MUTATIONS.REDUCE_LIST_ID_TO_RELOAD, student.courseId) : null;
          status.setLoad();          
        }).catch(() => {
          reject();
          status.setError();
        }).finally(() => {
          let student = this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected;
          this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.REFRESH_PERSON_STATUS, {student, isReload: false});
        });
      });
    },
    loadComponent(homework, componentName){
      this.myComponent = null;
      this.$nextTick(()=> {
        this.myComponent = componentName;
        this.currentHomework = homework;
      });
    },
    clickShowFeedback(homework){
      this.loadComponent(homework, 'ed-homework-feedback');
    },
    clickShowGrade(homework) {
      this.homeworkSelected = homework;
      this.loadComponent(homework, 'ed-homework-grade');
    },
    saveComponent(params){
      if(this.myComponent == 'ed-homework-grade'){
        this.savingGrade(params);
      }else if(this.myComponent == 'ed-homework-feedback'){
        this.savingFeedback(params);
      }
    },
    closeComponent() {
      this.myComponent = null;
    },
    savingGrade(data) {
      let student = this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected;
      this.homeworkSelected.grade = data.grade;
      this.isSaving = true;
      this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SET_TEACHER_HOMEWORK_GRADE, 
        { req: this.homeworkSelected, student }
      ).finally(() => {
        this.isSaving = false;
        this.myComponent = null;
      });
    },
    savingFeedback(data){
      let params = this.getParamsBaseToFeedback(data);
      let modal = data.modalHomework ? data.modalHomework : data.modal;
      this.$EdModal.createModal(modal,  params);
    },
    formatFileFeedback(data) {
      return {
        homework: {
          id: this.currentHomework.id,
          name: data.name,
          description: data.description,
          type: data.type,
          classId: this.studentSelected.classId,
          grade: data.grade
        },
        isResponse: false
      };
    },
    getParamsBaseToFeedback(data){
      let params: any = {
        section : {
          name: this.$i18n.t(`common.${data.type}`),
          classId: this.studentSelected.classId,
          type: data.code,
        },
        courseId: this.currentHomework.courseId,
        canSetHomework: false,
        titleModal : `${this.$i18n.t(`common.${data.type}`)} ${this.$i18n.t('common.feedback')}`,
        objId: this.studentSelected.id,
        modalBusSaveEvent: EVENT_BUS.RESPONSE_HOMEWORK_MODAL,
        formatData: this.formatFileFeedback,
        hasGradeField: true
      }
      if(data.code == SECTION_TYPES.LESSON_TEMP_FILE.code || data.code == SECTION_TYPES.LESSON_IMAGES.code) {
        let dropOptions: any = {
          url: HOMEWORKS_API.UPDATE_HOMEWORK.replace('{homeworkId}', this.currentHomework.id),
          autoProcessQueue: false,
          acceptedFiles: 'application/pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt',
          addRemoveLinks: false,
          maxFiles: 1,
          paramName: 'homeworkResource',
          parallelUploads: 1,
          createImageThumbnails: false,
          method: 'put'
        }
        if(data.code == SECTION_TYPES.LESSON_IMAGES.code) {
          dropOptions.createImageThumbnails = true;
          dropOptions.acceptedFiles= 'image/*';
        } else {
          dropOptions.maxFilesize= 200;
          dropOptions.timeout= 90000;
        }
        params.modalBusSaveEvent= `${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY`
        params.dropOptions = dropOptions;
      }
      return params;
    },
    saveModal(data, params) {
      switch (params.section.type) {
        case SECTION_TYPES.LESSON_TEXT.code:
        case SECTION_TYPES.LESSON_EXTERNAL_LINK.code:
        case SECTION_TYPES.LESSON_VIDEO.code:
          if(params.section) {
            if(params.section.type !== null) data.type = params.section.type;
          }
          this.$root.$children[0].$children[0].$refs.EdLoading.show();
          this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SEND_FEEDBACK_TO_STUDENT, { 
            req: {
              id: this.currentHomework.id,
              classId: this.studentSelected.classId,
              name: data.name,
              description: data.description,
              type: data.type,
              text: data.text,
              grade: data.grade
            },
            student: this.studentSelected,
            file: null,
          }).finally(() => {
            this.closeComponent();
            this.$EdModal.$emit(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_CLOSE`);
            this.$root.$children[0].$children[0].$refs.EdLoading.hide();
          });
        break;
      }
    },
    updateFeedback() {
      if(this.currentHomework){
        this.currentHomework.status = HOMEWORK_STATUS.GRADED;
        this.$store.commit(STORE.HOMEWORKS.MUTATIONS.UPDATE_WIDGET_TEACHER_PERSON, { 
          student:this.studentSelected, 
          homework: this.currentHomework
        });
      }
    },
    updateFeedbackTeacherHomeworkStatus(homeworkInfo) {
        let courseIndex = this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content.findIndex(cs => cs.id == homeworkInfo.courseId);
    
        if(!this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex]) {
          return;
        }

        let personIndex = this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex].persons.content.findIndex(s => s.id == homeworkInfo.studentId);
        if(personIndex === -1) {
          return;
        }

        if(this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex].persons.content[personIndex].homeworks.content.length > 0){
          let student = {...this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex].persons.content[personIndex]};
          student.homeworks.page = 0;
        }
    }
  },
  created() {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.LOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, this.setStudent);
    this.$edEventBus.$on(EVENT_BUS.RESPONSE_HOMEWORK_MODAL, this.saveModal);
    this.$edEventBus.$on(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY`, () => {
      this.updateFeedback();
      this.closeComponent();
      this.$EdModal.$emit(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY_CLOSE`);
    });
    this.$edEventBus.$on(HOMEWORKS_EVENTS.RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, this.reloadStudent);
  },
  mounted() {
    if(this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected) {
      this.homeworksStatus.setLoad();
      this.setStudent(this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected, false);
    }
    this.$edEventBus.$on(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS_FEEDBACK, this.updateFeedbackTeacherHomeworkStatus);
  },
  beforeDestroy() {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.LOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, this.setStudent);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, this.reloadStudent);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS_FEEDBACK, this.updateFeedbackTeacherHomeworkStatus);
  }
});
